module.exports = __webpack_public_path__ + "static/media/mesh basket.14.5aae7f2e.png";